export default ($) => {
	toggleAllAccordions();

	function toggleAllAccordions() {
		let expandBtns = document.getElementsByClassName('accordion-expand');
		let collapseBtns = document.getElementsByClassName('accordion-collapse');

		if (typeof expandBtns !== 'undefined' && expandBtns !== null) {

			for (let eb=0; eb<expandBtns.length; eb++) {

				expandBtns[eb].addEventListener('click', function(e){
					e.preventDefault();
					expandAccordions();
				});

				expandBtns[eb].addEventListener('keydown', function(e){
					e.preventDefault();
					if (e.keyCode === 13) {
						expandAccordions();
					}
				});
			}
		}

		if (typeof collapseBtns !== 'undefined' && collapseBtns !== null) {

			for (let cb=0; cb<expandBtns.length; cb++) {

				collapseBtns[cb].addEventListener('click', function(e){
					e.preventDefault();
					collapseAccordions();
				});

				collapseBtns[cb].addEventListener('keydown', function(e){
					e.preventDefault();
					if (e.keyCode === 13) {
						collapseAccordions();
					}
				});
			}
		}
	}

	function expandAccordions() {
		let accordions = document.getElementsByTagName('details');

		if (typeof accordions !== 'undefined' && accordions !== null) {

			for (let la=0; la<accordions.length; la++) {
				accordions[la].setAttribute('open', '');
			}
		}
	}

	function collapseAccordions() {
		let accordions = document.getElementsByTagName('details');

		if (typeof accordions !== 'undefined' && accordions !== null) {

			for (let la=0; la<accordions.length; la++) {
				accordions[la].removeAttribute('open');
			}
		}
	}
}